import { ImageFallback, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

interface ProductInfoProps {
  productName: string;
  managerImage: string;
  productTypeName: string;
}
export const ProductInfoMobile: React.FC<ProductInfoProps> = ({
  productName,
  managerImage,
  productTypeName,
}) => {
  return (
    <>
      <VStack
        bg="white"
        justifyContent="flex-start"
        mt={Spacing['stack.xxxs']}
        px={Spacing['inline.xxs']}
        py={Spacing['stack.xxs']}
        space={Spacing['stack.nano']}>
        <Text
          fontSize={Typography['fontsize.md']}
          variant="semibold"
          color="brand.primary.principal">
          Bloqueio de {productName}
        </Text>
        <HStack alignItems="center" justifyContent="space-between">
          <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.medium">
            Emissor
          </Text>
          <ImageFallback
            src={managerImage}
            alt="logo"
            width="54px"
            height="48px"
            testID="product-img"
            resizeMode="cover"
            borderRadius={BoxRadius.sm}
            resizeMethod="scale"
          />
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.medium">
            Nome
          </Text>
          <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.black">
            {productName}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.medium">
            Tipo de produto
          </Text>
          <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.black">
            {productTypeName.toUpperCase()}
          </Text>
        </HStack>
      </VStack>
    </>
  );
};
